import { Button, Card, ConfigProvider, Row, Space, theme } from 'antd';
import { useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditOrganizationFormValues } from '../../../../../../../../types/organizationform';
import ResetFormButton from '../../../../../../../components/Forms/ResetFormButton';
import CustomOrganizationFieldsContainer from './CustomOrganizationFormFieldsContainer';
import StandardOrganizationFieldsContainer from './StandartOrganizationFieldsContainer';

const EditOrganizationFieldsContainer = () => {
    const { t } = useTranslation('forms');
    const {
        token: { marginSM, paddingXXS, borderRadius }
    } = theme.useToken();
    const { reset } = useFormContext<EditOrganizationFormValues>();

    //HACK: Bünyamin => isDirty is common usage to check is form dirty or not but our form's default values are not same the EditOrganizationFormValues type in our case
    // and this causing isDirty not working for form's initial state.
    // in official react-hook-form documentation says isDirty: getValues() === defaultValues and
    // in our case default value of fields is  fields:{} bu we change this to fields:{os$external_id: undefined} is side the form and these are not same.
    const { dirtyFields } = useFormState<EditOrganizationFormValues>();
    const isRealDirty = dirtyFields && Object.keys(dirtyFields).length > 0;
    return (
        <ConfigProvider getPopupContainer={(trigger) => trigger?.parentElement}>
            <Space direction="vertical" size="small" className="full-width">
                <Card
                    bodyStyle={{ padding: paddingXXS * 3 }}
                    style={{ borderRadius: borderRadius, border: '1px solid rgba(0, 0, 0, 0.12)', marginTop: marginSM }}
                >
                    <StandardOrganizationFieldsContainer />
                </Card>
                <Card
                    bodyStyle={{ padding: paddingXXS * 3 }}
                    style={{
                        borderRadius: borderRadius,
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        marginBottom: marginSM
                    }}
                >
                    <CustomOrganizationFieldsContainer isActive={true} />
                    <Row justify="space-between" style={{ marginTop: marginSM }}>
                        <ResetFormButton onClick={() => reset()} disabled={!isRealDirty} />
                        <Button type="primary" htmlType="submit" disabled={!isRealDirty}>
                            {t('userForm.saveChanges')}
                        </Button>
                    </Row>
                </Card>
            </Space>
        </ConfigProvider>
    );
};

export default EditOrganizationFieldsContainer;
